import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../actions';

import * as globalActions from '../../../action/CommonActions';

import { notify, closeNotify } from '../../../components/libs/notification';
import { fetchDriverAllocationDetails } from '../../relocations/driver/actions';
import {
  getDriverAllocation,
  getDriverAllocationCCAndCountry
} from '../../relocations/driver/selector';
import {
  dashboardProfileSelector,
  dashboardNotesSelector,
  commonSelector,
  authSelector
} from '../selectors';

const select = createStructuredSelector({
  profile: dashboardProfileSelector,
  notes: dashboardNotesSelector,
  common: commonSelector,
  auth: authSelector
});

const mapStateToProps = state => {
  const res = select(state);
  const {
    fetchingDriverAllocationDetails,
    driverAllocationDetails
  } = getDriverAllocation(state);
  const { costcenter, country } = getDriverAllocationCCAndCountry(state);

  return {
    ...res,
    fetchingDriverAllocationDetails,
    driverAllocationDetails,
    company: costcenter,
    country
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  fetchDriverAllocationDetails: bindActionCreators(
    fetchDriverAllocationDetails,
    dispatch
  ),
  globalActions: bindActionCreators(globalActions, dispatch),
  notify: bindActionCreators(notify, dispatch),
  closeNotify: bindActionCreators(closeNotify, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps);



// WEBPACK FOOTER //
// ./src/features/dashboard/dataProvider/index.js